export default function Contact() {
  return null;
}



// WEBPACK FOOTER //
// ./src/components/Contact.js